<template>
  <div class="map-popup">
    <div class="map-popup__header">
      <p v-if="props.cards.length === 0" class="map-popup__title">
        Выберите на карте интересующие вас анкеты
      </p>
      <p v-else class="map-popup__title">
        Выбранная точка<span class="map-popup__title-count">{{ profileCountText }}</span>
      </p>
      <ArrowIcon
        class="map-popup__arrow"
        :class="{ 'map-popup__arrow_active': visible }"
        @click="emits('toggleList')"
      />
    </div>
    <ProfilesList v-if="visible && props.cards.length" :cards="props.cards"/>
  </div>
</template>

<script lang="ts" setup>
import ProfilesList from "@/mapSearch/components/MapProfiles/ProfilesList.vue";
import { PropType, computed } from "vue";
import ProfileCardInterface from "@/common/types/ProfileCardInterface";
import ArrowIcon from "@/common/icons/ArrowIcon.vue";

const props = defineProps({
  cards: {
    type: Array as PropType<Array<ProfileCardInterface>>,
    required: true,
  },
  visible: {
    type: Boolean,
    required: true,
  },
})

const emits = defineEmits(['toggleList']);

const profileCountText = computed(() => {
  if (props.cards.length % 10 === 1 && props.cards.length !== 11) {
    return `${props.cards.length} анкета`
  }

  if ([2, 3, 4].includes(props.cards.length % 10)) {
    return `${props.cards.length} анкеты`
  }

  return `${props.cards.length} анкет`
})
</script>

<style scoped>
.map-popup {
  @media screen and (max-width: 768px) {
    position: absolute;
    max-width: unset;
    width: unset;
    bottom: -616px;
    background: none !important;
    border: none !important;
  }

  &__header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 16px;
    background: rgb(9, 10, 12);
    border-radius: 16px;

    @media screen and (max-width: 768px) {
      display: none;
    }
  }

  &__title {
    font-family: Inter;
    font-size: 14px;
    font-weight: 700;
    line-height: 16px;
    
    &-count {
      margin-left: 8px;
      color: black;
      background: rgba(89, 236, 52, 1);
      border-radius: 6px;
      padding: 2px 3px;
      font-size: 12px;
      font-weight: 600;
    }
  }

  &__arrow {
    cursor: pointer;

    &_active {
      transform: rotate(180deg);
    }
  }

  :deep(.profiles-list) {
    @media screen and (max-width: 768px) {
      display: flex;
      padding: 0 100px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .profile-card {
      @media screen and (max-width: 768px) {
        min-width: 165px;
        background: rgb(9, 10, 12);
      }

      &__photo {
        margin-bottom: 0;
      }
    }
  }
}
</style>